import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractSearchDataProvider } from '@entity-framework/entity-search/abstract-search.data-provider';
import { LoggingService } from '@logging/logging.service';
import { environment } from '@env/environment';
import { ActiveSecurityContextStateService } from '@security/active-security/active-security-context.state-service';
import { BureauPaymentPeriodListItem } from '@app/bureau/payments/payment-periods/models/bureau-payment-period-list-item';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { convertToHierarchyDataSetItem } from '@app/bureau/teams/edit-modal/state/team-hierarchy-helper';
import { TeamFlattenedHierarchyDataset } from '@app/bureau/teams/models/teams-hierarchy';
import { BureauPaymentPeriodSearchRequest } from '../../models/bureau-payment-period-search-request';
import { BureauPaymentPeriodFilters, BureauPaymentPeriodFiltersResponse } from '../../models/bureau-payment-period-filters-response';

@Injectable({ providedIn: 'root' })
export class BureauPaymentPeriodsSearchDataProvider extends AbstractSearchDataProvider<
  BureauPaymentPeriodListItem,
  BureauPaymentPeriodSearchRequest
> {
  constructor(
    protected httpClient: HttpClient,
    protected logger: LoggingService,
    private activeSecurity: ActiveSecurityContextStateService
  ) {
    super(httpClient, logger);
    this.useQueryForParameters = true;
  }

  searchEndpoint(): string {
    return `${environment.apiPaths.bureau}/${this.activeSecurity.activeBureau.id}/bank-file-periods/search`;
  }

  getFilters$(): Observable<BureauPaymentPeriodFilters> {
    return this.httpClient.get(`${environment.apiPaths.bureau}/${this.activeSecurity.activeBureau.id}/bank-file-periods/filters`).pipe(
      take(1),
      map((response: BureauPaymentPeriodFiltersResponse) => {
        return {
          teams: response.teams ? new TeamFlattenedHierarchyDataset([...convertToHierarchyDataSetItem(response.teams)]) : null,
          paymentTypes: response.paymentTypes,
          statuses: response.statuses
        } as BureauPaymentPeriodFilters;
      })
    );
  }

  getAnyOutstandingSalaryPayments$(): Observable<boolean> {
    return this.httpClient
      .get(`${environment.apiPaths.bureau}/${this.activeSecurity.activeBureau.id}/bank-file-periods/any-outstanding-salary-payments`)
      .pipe(
        take(1),
        map((response: { hasOutstandingSalaryPayments: boolean }) => response.hasOutstandingSalaryPayments)
      );
  }
}
